module.exports = __webpack_public_path__ + "img/cash-in-hand.6a890a2c.svg";